module.exports = __webpack_public_path__ + "media/images/career_camp/2022/hero/uni_right-aa6fa7c7d08a8ac9252c72d159eee0db.svg";